    /* Getting all elements with the parallax class */
    var parallaxElements = document.querySelectorAll(".parallax");

    window.addEventListener('scroll', () => {

        /* How much the entire page has scrolled */
        var scroll = window.pageYOffset;

        /* Parallax Effect */
        for(var i=0; i < parallaxElements.length; i++) {

            /* Get the speed from the HTML element data property */
            var speed = parallaxElements[i].dataset.parallaxSpeed;

            /* use CSS translateY property to scroll */
            parallaxElements[i].style.transform = `translateY(${scroll * speed}px)`;
        };
    });
